var _g, _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectors(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 171.187,
    height: 57.1641,
    viewBox: "0 0 171.187 57.1641",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M57.1641 28.582L28.582 57.1641L0 28.582L28.582 0L57.1641 28.582ZM13.5742 28.582L28.582 43.5898L43.5898 28.582L28.582 13.5742L13.5742 28.582Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("foreignObject", {
    x: 15.5569,
    y: -41.7567,
    width: 140.677,
    height: 140.677
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(20.88px)",
      clipPath: "url(#bgblur_0_0_40_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 49",
    opacity: 0.99,
    "data-figma-bg-blur-radius": 41.7567
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.8955,
    width: 40.4209,
    height: 40.4209,
    transform: "rotate(45 85.8955 0)",
    fill: "url(#paint0_linear_0_40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.8955,
    y: 0.624238,
    width: 39.5381,
    height: 39.5381,
    transform: "rotate(45 85.8955 0.624238)",
    stroke: "url(#paint1_linear_0_40)",
    strokeOpacity: 0.33,
    strokeWidth: 0.882806
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    d: "M171.187 28.582L142.605 57.1641L114.023 28.582L142.605 0L171.187 28.582Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_0_40_clip_path",
    transform: "translate(-15.5569 41.7567)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.8955,
    width: 40.4209,
    height: 40.4209,
    transform: "rotate(45 85.8955 0)"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_40",
    x1: 85.8955,
    y1: 20.2104,
    x2: 126.316,
    y2: 20.2104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.5,
    style: {
      stopColor: "#D9D9D9",
      stopColor: "color(display-p3 0.8510 0.8510 0.8510)",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_40",
    x1: 106.106,
    y1: 0,
    x2: 106.106,
    y2: 40.4209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    style: {
      stopColor: "#D9D9D9",
      stopColor: "color(display-p3 0.8510 0.8510 0.8510)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616",
    style: {
      stopColor: "#161616",
      stopColor: "color(display-p3 0.0863 0.0863 0.0863)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectors);
export default __webpack_public_path__ + "static/media/connectors.578395553f9ef5e15b1007759f01a01b.svg";
export { ForwardRef as ReactComponent };